import communityWalkthrough from '../../modules/community/walkthrough/ss.json';

export const SS = {
  translation: {
    ...communityWalkthrough,
  },
};
